import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinkhadkibhigwan() {



const cardData =
  {
    keyword: 'Bus On Rent in Khadki Bhigwan',
    heading: 'Sanavi Travels: Bus On Rent in Khadki Bhigwan',
    headingDescription: 'Sanavi Travels provides dependable and professionally managed Bus On Rent in Khadki Bhigwan, catering to tourists, local residents, families, corporate teams, schools, wedding groups, and picnic travelers. Khadki Bhigwan, located near the Bhigwan region of Pune district, is well-known for its proximity to the Ujani backwaters, bird sanctuary routes, and rural tourism circuits, resulting in frequent demand for organized group transportation.',

    top: 'Top Places to Visit Near Khadki Bhigwan with Sanavi Travels',


"topPlaces": [
  {
    "title": "Khadki Bhigwan Village",
    "description": "Khadki Bhigwan is a peaceful rural village surrounded by agricultural land and water bodies, offering a calm environment and strong community culture. The village frequently hosts weddings, religious programs, family gatherings, and social events that require reliable group transportation. Bus rentals are widely used to manage guest movement efficiently, reduce travel coordination challenges, and ensure everyone reaches destinations together and on time."
  },
  {
    "title": "Bhigwan Bird Sanctuary Route",
    "description": "The road connecting Khadki Bhigwan to Bhigwan Bird Sanctuary is a popular travel route for nature lovers, photographers, students, and tourists. Migratory birds such as flamingos and pelicans attract visitors seasonally, often in large groups. Hiring a bus ensures comfortable group travel, easy scheduling, and safe transportation for early morning and full-day bird-watching trips."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The Ujani backwaters near Khadki Bhigwan offer scenic landscapes, boating views, and serene natural surroundings. Group visits for leisure, photography, and eco-tourism are common. Bus hire services provide smooth access to these locations, allowing groups to travel together while enjoying the journey without worrying about parking or route planning."
  },
  {
    "title": "Bhigwan Town Connectivity",
    "description": "Bhigwan town serves as a local center for markets, lodging, food facilities, and tourist coordination. Many travelers stay in Bhigwan while exploring nearby villages and nature spots. Bus rentals help manage regular movement between Khadki Bhigwan and Bhigwan town comfortably and economically."
  },
  {
    "title": "Indapur and Daund Travel Routes",
    "description": "Khadki Bhigwan is well connected to Indapur and Daund, making these towns frequent travel destinations for education, healthcare, business, and events. Group travel using buses ensures punctual arrivals and safe transportation across both rural and highway roads."
  },
  {
    "title": "Pune–Solapur Highway Access",
    "description": "The nearby Pune–Solapur Highway provides smooth connectivity to Pune city, Solapur, Baramati, and surrounding regions. Bus rentals are ideal for highway travel, offering comfort, safety, and cost efficiency for large groups traveling long distances."
  },
  {
    "title": "Local Temples and Spiritual Sites",
    "description": "Several small temples and religious centers around Khadki Bhigwan attract devotees during festivals and special occasions. Bus hire services help organize group pilgrimages, ensuring convenient and stress-free travel for all age groups."
  },
  {
    "title": "Picnic and Nature Trails",
    "description": "Open rural spaces, lakeside areas, and natural trails near Khadki Bhigwan make it a popular picnic destination for schools, colleges, and families. Hiring a bus allows groups to enjoy the outing together while maintaining safety and travel discipline."
  },
  {
    "title": "Educational and Study Tours",
    "description": "Schools and colleges frequently organize educational trips to Bhigwan and surrounding ecological zones. Bus rentals ensure safe, supervised, and punctual transportation for students and teaching staff."
  },
  {
    "title": "Outstation Travel Destinations",
    "description": "Khadki Bhigwan serves as a convenient starting point for travel to Pune, Solapur, Ahmednagar, Baramati, and pilgrimage destinations. Bus rentals provide a comfortable and economical solution for long-distance group travel."
  }
]
,



"services": [
{
"name": "Bus On Rent in Khadki Bhigwan",
"description": "Bus On Rent in Khadki Bhigwan offers spacious, comfortable, and professionally managed buses for tourists, families, schools, and corporate groups. This service is ideal for bird sanctuary tours, weddings, picnics, corporate outings, and outstation travel. Our buses feature clean interiors, cushioned seating, smooth suspension, proper ventilation, and ample luggage space, ensuring a relaxed journey even on longer routes. Experienced drivers handle rural roads and highway routes efficiently, providing punctual pickups, disciplined driving, and complete passenger safety throughout the journey."
},
{
"name": "Bus Hire Khadki Bhigwan",
"description": "Bus Hire Khadki Bhigwan provides flexible and reliable transportation for local village travel, social events, and long-distance trips. With well-maintained buses and professional drivers, this service ensures organized and stress-free group travel for every occasion."
},
{
"name": "AC Bus Rental Khadki Bhigwan",
"description": "AC Bus Rental Khadki Bhigwan is perfect for summer travel and extended journeys, offering air-conditioned comfort, improved passenger convenience, and a smooth travel experience for weddings, corporate travel, and tourism groups."
},
{
"name": "Non AC Bus on Rent Khadki Bhigwan",
"description": "Non AC Bus on Rent Khadki Bhigwan offers economical transportation for short-distance travel, rural routes, school trips, and local group movements while maintaining safety and reliability."
},
{
"name": "Luxury Bus on Rent Khadki Bhigwan",
"description": "Luxury Bus on Rent Khadki Bhigwan delivers a premium travel experience with modern interiors, superior seating, enhanced comfort, and professional service, ideal for weddings, VIP travel, and special events."
},
{
"name": "Mini Bus Hire Khadki Bhigwan",
"description": "Mini Bus Hire Khadki Bhigwan is suitable for small to medium-sized groups such as families, office teams, and tourist batches, offering flexible scheduling and cost-effective travel."
},
{
"name": "32 Seater Bus on Rent Khadki Bhigwan",
"description": "32 Seater Bus on Rent Khadki Bhigwan is ideal for school excursions, corporate outings, and medium group travel, balancing seating capacity with comfort and safety."
},
{
"name": "35 Seater Bus Hire Khadki Bhigwan",
"description": "35 Seater Bus Hire Khadki Bhigwan supports large group transportation needs such as weddings, religious tours, and long-distance travel with organized seating and reliable service."
},
{
"name": "Bus on Rent Khadki Bhigwan for Wedding",
"description": "Bus on Rent Khadki Bhigwan for Wedding ensures coordinated and timely transportation for wedding guests, reducing logistical challenges and ensuring smooth event management."
},
{
"name": "Bus on Rent Khadki Bhigwan for Corporate",
"description": "Bus on Rent Khadki Bhigwan for Corporate offers professional transport solutions for employee movement, meetings, conferences, and team outings with punctual and reliable service."
},
{
"name": "Bus on Rent Khadki Bhigwan for Picnic",
"description": "Bus on Rent Khadki Bhigwan for Picnic provides safe and enjoyable group travel for school picnics, college outings, and family leisure trips."
},
{
"name": "Bus Rental Khadki Bhigwan Outstation",
"description": "Bus Rental Khadki Bhigwan Outstation delivers dependable long-distance transportation to nearby cities and pilgrimage destinations with comfort and safety as top priorities."
},
{
"name": "Bus Hire Khadki Bhigwan with Driver",
"description": "Bus Hire Khadki Bhigwan with Driver offers chauffeur-driven buses where experienced drivers manage routes, traffic, and safety, allowing passengers to travel stress-free."
},
{
"name": "Affordable Bus Rental Khadki Bhigwan",
"description": "Affordable Bus Rental Khadki Bhigwan provides cost-effective transportation solutions without compromising on cleanliness, comfort, or service quality."
},
{
"name": "Best Bus Service Khadki Bhigwan",
"description": "Best Bus Service Khadki Bhigwan is trusted for clean buses, punctual operations, transparent pricing, and customer-focused service delivered by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Khadki Bhigwan", "Bus Hire Khadki Bhigwan"],
["AC Bus Rental Khadki Bhigwan", "Non AC Bus Hire Khadki Bhigwan"],
["Luxury Bus Khadki Bhigwan", "Mini Bus Hire Khadki Bhigwan"],
["32 Seater Bus Khadki Bhigwan", "35 Seater Bus Khadki Bhigwan"],
["Wedding Bus Khadki Bhigwan", "Corporate Bus Khadki Bhigwan"],
["Picnic Bus Khadki Bhigwan", "Outstation Bus Khadki Bhigwan"],
["Bus Hire Khadki Bhigwan with Driver", "Affordable Bus Rental Khadki Bhigwan"],
["Best Bus Service Khadki Bhigwan", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Khadki Bhigwan with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and professionally managed bus rental services in Khadki Bhigwan for tourism, events, and group travel."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "All buses are regularly serviced and cleaned to ensure passenger comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Drivers are well familiar with Khadki Bhigwan, Bhigwan, Daund, and highway routes."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear and honest pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and travel support."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, full-day, and outstation rental plans available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every journey."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth travel operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Khadki Bhigwan?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Khadki Bhigwan.'
  },
  {
    question: 'What buses are available in Khadki Bhigwan?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus rental available for Bhigwan bird sanctuary trips?',
    answer: 'Yes, buses are available for bird sanctuary and eco-tourism trips.'
  },
  {
    question: 'Can I book a bus for outstation travel from Khadki Bhigwan?',
    answer: 'Yes, outstation bus rentals are available from Khadki Bhigwan.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Jadhav',
    feedback: 'We hired a bus from Khadki Bhigwan for a bird sanctuary trip. Very smooth and comfortable experience.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Khadki Bhigwan. Clean bus and polite driver.',
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Bhandgaon Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Bhandgaon Pune for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Bhandgaon Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Bhandgaon Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/227.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinkhadkibhigwan;